(function ($) {
	'use strict';

	$('.js-tabs').on('click', function (e) {
		e.preventDefault();
		const parentTabs = $(this).parents('[data-tabs]')
		const currentTab = $(this).parent().attr('data-tab')

		// on vire la classe is-active sur tous
		parentTabs.find('[data-tab]').removeClass('is-active')

		// // on l'ajoute sur la nouvelle
		parentTabs.find('[data-tab="' + currentTab + '"]').addClass('is-active')
	})

})(jQuery);
